import { ButtonComponent } from '@syncfusion/ej2-react-buttons'
import { ReactNode } from 'react'

type CustomCardProps = {
  header?: string
  headerBadgeContent?: string
  headerBtnLabel?: string
  headerBtnAction?: (event?: React.MouseEvent<HTMLButtonElement>) => void
  headerBtnIcon?: string
  headerBtnDisabled?: boolean
  children?: ReactNode
  noBottomMargin?: boolean
  style?: React.CSSProperties
  contentStyle?: React.CSSProperties
}

const CustomCard: React.FC<CustomCardProps> = ({ header, headerBtnLabel, headerBtnAction, headerBadgeContent, headerBtnIcon, headerBtnDisabled, children, noBottomMargin, style, contentStyle }) => {
  const defaultStyles = {
    overflow: 'auto',
    justifyContent: 'start',
    marginBottom: noBottomMargin ? '0' : undefined,
  }

  const mergedStyles = {
    ...defaultStyles,
    ...style,
  }

  return (
    <div className="e-card customCard" style={mergedStyles}>
      {header && (
        <div className="e-card-header">
          <div className="e-card-header-caption">
            <div className="e-card-header-title">
              {header}
              {headerBadgeContent && <span className="e-badge e-badge-primary">{headerBadgeContent}</span>}
            </div>
          </div>
          {headerBtnLabel && (
            <ButtonComponent
              type="button"
              isPrimary
              disabled={headerBtnDisabled}
              cssClass={headerBtnIcon ? `iconBtn` : ''}
              iconCss={headerBtnIcon ? `e-icons ${headerBtnIcon}` : ''}
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                if (headerBtnAction) {
                  headerBtnAction(e)
                }
              }}
            >
              {headerBtnLabel}
            </ButtonComponent>
          )}
        </div>
      )}

      <div className="e-card-content" style={contentStyle}>
        {children}
      </div>
    </div>
  )
}

export default CustomCard
